import './init/log.js';
import EventEmitter from 'event-emitter';
import Interface from './interface';
import log from 'loglevel';
import { vhallBaseBlock } from './utils/utils';
import { version } from '../package.json';
import EVENT from './init/event_enum.js';
class VhallMsg {
  static channlIdMap = {};
  static version = version;

  static async createInstance(opt, success, failure) {
    if (!opt) {
      const e = { code: '', message: '无效的参数', data: {} };
      failure && failure(e);
      throw e;
    }
    opt.accountId = opt.accountId || opt.third_party_user_id;
    opt.third_party_user_id = opt.accountId;
    if (!(opt.accountId && opt.appId && opt.channelId)) {
      const e = { code: '', message: '无效的参数', data: {} };
      failure && failure(e);
      throw e;
    }

    let instance = VhallMsg.channlIdMap[opt.channelId];
    if (instance) {
      instance.updateOption(opt);
      success && success(instance);
      return instance;
    }
    log.info(`createInstance opt:${JSON.stringify(opt)}`);
    instance = new Interface(VhallMsg, opt);
    try {
      await instance.init();

      const ins = VhallMsg.channlIdMap[opt.channelId];
      if (ins) {
        ins.updateOption(opt);
        success && success(ins);
        return ins;
      }

      VhallMsg.channlIdMap[opt.channelId] = instance;
    } catch (err) {
      console.log(err);
      const e = {
        code: err.code,
        data: err.data,
        message: err.msg
      };
      failure && failure(e);
      throw e;
    }
    success && success(instance);
    return instance;
  }

  static destroyInstance(channelId) {
    const inst = VhallMsg.channlIdMap[channelId];
    if (inst) inst.destroy();
  }

  /**
   * 派发广播消息
   * @param {custom} data 广播参数  任意格式
   */
  static emitBroadcast(data) {
    VhallMsg.emit('broadcast', data);
  }

  /**
   * 监听广播消息
   * @param {function} callback 回调函数
   */
  static onBroadcast(callback) {
    VhallMsg.on('broadcast', callback);
  }

  static EVENT = EVENT;
}

EventEmitter(VhallMsg);
vhallBaseBlock();

export default VhallMsg;
